import { Routes } from '@angular/router';

export const authLayoutRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@shared/pages/login/login.component').then((c) => c.LoginComponent),
    title: 'routes.login',
    // `authCover` menyalakan kolom kiri; `authDocs` menyalakan daftar "Dokumen & Panduan Vendor"
    // di bawah form. Keduanya milik AuthLayoutComponent — lihat komentar kelasnya.
    //
    // `authDocs` HANYA di sini. Dipasang sebagai data route, bukan dengan mencocokkan
    // `router.url === '/auth/login'` di layout: kalau kelak route login pindah/ditambah alias,
    // pencocokan string akan gagal DIAM-DIAM (daftar dokumennya cuma hilang, tanpa error).
    data: { authCover: true, authDocs: true },
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('@shared/pages/forgot-password/forgot-password.component').then(
        (c) => c.ForgotPasswordComponent,
      ),
    title: 'routes.forgotPassword',
    // Selebar kolom form login, jadi kolom sampul bergambar muat.
    data: { authCover: true },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('@shared/pages/register/register.component').then((c) => c.RegisterComponent),
    title: 'routes.register',
    // Sama seperti login. Sempat dimatikan karena halaman register selebar 68rem dengan grid
    // dua kolom tidak muat di kolom 50%; sekarang seluruh breakpoint-nya (grid form, bentuk
    // stepper, footer langkah) membaca lebar KOLOM lewat container query + ResizeObserver,
    // bukan lebar viewport, jadi ia menyesuaikan diri sendiri.
    data: { authCover: true },
  },
];
